export const AVAILABLE_FONTS: string[] = ['Be Vietnam Pro'] as const
